import ReportSections from './ReportSections';

const ExpandableSections = [
    ReportSections.STRONG_POINTS,
    ReportSections.POINTS_OF_ATTENTION,
    ReportSections.DEVELOPMENT_ADVICE,
    ReportSections.RESEARCH_QUESTION,
    ReportSections.SELECTION_ADVICE,
    ReportSections.SELECTION_DEVELOPMENT_ADVICE,
    ReportSections.TEAM_ROLES,
    ReportSections.INTELLECTUAL_CAPABILITY_EXTENDED
];

export default ExpandableSections;
